module.exports = __webpack_public_path__ + "img/solar.1c6c2aa8.jpg";